import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { BinaOptionsModel, BinaPartialOptionsModel, PaginatedResultModel, PreliminaryDutiesSearchModel } from '@data-layer/models/common';
import { FavoriteHtsNumberModel } from '../models/common/favorite-hts-number.model';
import { FavoriteHtsNumberSearchModel } from '../models/common/favorite-hts-number-search.model';
import { FavoriteHtsNumberCreateModel } from '../models/common/favorite-hts-number-create.model';
import { FavoriteHtsNumberUpdateModel } from '../models/common/favorite-hts-number-update.model';
import { DutiesCalculationResponseModel } from '../models/common/duties-calculation-response.model';
import { catchError } from 'rxjs/operators';
import { AlertService } from '@services/alert.service';
import { enumRespErrors } from '../enums/common';

@Injectable({
  providedIn: 'root',
})
export class BinaRepository {
  constructor(private alertService: AlertService, private apiService: ApiService) {}

  public getDescription(partialHtsCode: string): Observable<string> {
    return this.apiService.get(
      `${environment.url.prefixCustoms}v2/hts-classifier/${partialHtsCode}/description`,
      { responseType: 'text' },
      {
        isShowLoader: false,
      },
    );
  }

  public getPreliminaryDuties(params: PreliminaryDutiesSearchModel, isShowLoader?: boolean): Observable<DutiesCalculationResponseModel> {
    return this.apiService.get(
      `${environment.url.prefixCustoms}v2/preliminary-duties`,
      {
        params,
      },
      { isShowLoader },
    );
  }

  public getOptions(partialHtsCode: string): Observable<BinaPartialOptionsModel> {
    return this.apiService.get(`${environment.url.prefixCustoms}v2/hts-classifier/${partialHtsCode}`, null, {
      isShowLoader: false,
    });
  }

  public getClassification(query: string, importerId?: number, manufacturerId?: number): Observable<BinaOptionsModel> {
    const params: { query: string; importerId?: number; manufacturerId?: number } = { query };

    if (importerId != null) {
      params.importerId = importerId;
    }

    if (manufacturerId != null) {
      params.manufacturerId = manufacturerId;
    }

    return this.apiService.get(
      `${environment.url.prefixCustoms}v2/hts-classifier`,
      { params },
      {
        isShowLoader: false,
      },
    );
  }

  public searchFavoriteHtsNumbers(
    params?: FavoriteHtsNumberSearchModel,
    isShowLoader?: boolean,
  ): Observable<PaginatedResultModel<FavoriteHtsNumberModel>> {
    return this.apiService.get<PaginatedResultModel<FavoriteHtsNumberModel>>(
      `${environment.url.companies}${params.companyId}/favorite-hts-numbers`,
      {
        params,
      },
      { isShowLoader },
    );
  }

  public createFavoriteHtsNumber(companyId: number, value?: FavoriteHtsNumberCreateModel, isShowLoader?: boolean): Observable<void> {
    return this.apiService.post(`${environment.url.companies}${companyId}/favorite-hts-numbers`, value, null, { isShowLoader });
  }

  public updateFavoriteHtsNumber(id: number, value: FavoriteHtsNumberUpdateModel, isShowLoader?: boolean): Observable<void> {
    return this.apiService.put(`${environment.url.favoriteHts}${id}`, value, null, { isShowLoader });
  }

  public deleteFavoriteHtsNumber(id: number, isShowLoader?: boolean): Observable<void> {
    return this.apiService.delete(`${environment.url.favoriteHts}${id}`, null, { isShowLoader });
  }
}
